/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthTokenUser
 */
export interface OAuthTokenUser {
    /**
     * 
     * @type {string}
     * @memberof OAuthTokenUser
     */
    id: string;
}

/**
 * Check if a given object implements the OAuthTokenUser interface.
 */
export function instanceOfOAuthTokenUser(value: object): value is OAuthTokenUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function OAuthTokenUserFromJSON(json: any): OAuthTokenUser {
    return OAuthTokenUserFromJSONTyped(json, false);
}

export function OAuthTokenUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthTokenUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function OAuthTokenUserToJSON(json: any): OAuthTokenUser {
    return OAuthTokenUserToJSONTyped(json, false);
}

export function OAuthTokenUserToJSONTyped(value?: OAuthTokenUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

